__turbopack_context__.v({
  "answer": "FaqSection-module__xrDaIG__answer",
  "item": "FaqSection-module__xrDaIG__item",
  "itemOpen": "FaqSection-module__xrDaIG__itemOpen",
  "list": "FaqSection-module__xrDaIG__list",
  "question": "FaqSection-module__xrDaIG__question",
  "questiontext": "FaqSection-module__xrDaIG__questiontext",
  "section": "FaqSection-module__xrDaIG__section",
  "toggle": "FaqSection-module__xrDaIG__toggle",
  "toggleOpen": "FaqSection-module__xrDaIG__toggleOpen",
});
